import * as React from 'react';
import PropTypes from 'prop-types';
import { Box, Modal, Button, Stack, Typography, Divider, Chip, Alert } from '@mui/material';
import GppGoodIcon from '@mui/icons-material/GppGood';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '45vw',
  maxHeight: '90vh',
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: 3,
  overflowY: 'auto',
  backgroundColor: '#e3f2fd',
};

const campo = (label, value, destaque = false) => (
  <Stack direction="row" justifyContent="space-between" alignItems="center" py={0.5}>
    <Typography variant="body2" color="text.secondary">{label}</Typography>
    <Typography variant="body2" fontWeight={destaque ? 'bold' : 'normal'} color={destaque ? '#1565C0' : 'text.primary'}>
      {value || '—'}
    </Typography>
  </Stack>
);

export default function ModalPagamentoIndicador({ open, onClose, proposta }) {
  const indicador = proposta?.indicador;
  const tipoIndicacao = proposta?.tipoindicacao;
  const percentual = proposta?.percentualindicacao;

  if (!indicador) return null;

  const valorPagamento = tipoIndicacao?.valor
    ? `R$ ${tipoIndicacao.valor},00`
    : percentual
    ? `${percentual}% sobre R$ ${proposta?.valor?.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`
    : '—';

  const copiarPix = () => {
    if (indicador.chavepix) {
      navigator.clipboard.writeText(indicador.chavepix);
      window.alert('Chave PIX copiada!');
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Stack direction="row" alignItems="center" gap={1} mb={2}>
          <GppGoodIcon sx={{ color: '#1565C0' }} />
          <Typography variant="h6" fontWeight="bold" color="#1565C0">
            Dados para Pagamento — Acesso Restrito
          </Typography>
        </Stack>

        <Alert severity="warning" sx={{ mb: 2, fontSize: 12 }}>
          Estas informações são confidenciais e protegidas pela LGPD.
          Não compartilhe com terceiros.
        </Alert>

        {/* Dados do Indicador */}
        <Typography variant="subtitle2" color="primary" mb={1}>Indicador</Typography>
        <Box sx={{ backgroundColor: 'white', borderRadius: 1, p: 2, mb: 2 }}>
          {campo('Nome completo', indicador.nome, true)}
          <Divider />
          {campo('CPF/CNPJ', indicador.cpf)}
          <Divider />
          {campo('Telefone', indicador.telefone)}
          <Divider />
          {campo('Email', indicador.email)}
          <Divider />
          <Stack direction="row" justifyContent="space-between" alignItems="center" py={0.5}>
            <Typography variant="body2" color="text.secondary">Chave PIX</Typography>
            <Stack direction="row" alignItems="center" gap={1}>
              <Typography variant="body2" fontWeight="bold">{indicador.chavepix || '—'}</Typography>
              {indicador.chavepix && (
                <Button size="small" startIcon={<ContentCopyIcon />} onClick={copiarPix}>
                  Copiar
                </Button>
              )}
            </Stack>
          </Stack>
          {indicador.lgpd?.consentimento && (
            <>
              <Divider />
              {campo('Consentimento LGPD', `Registrado em ${new Date(indicador.lgpd.dataConsentimento).toLocaleDateString('pt-BR')} por ${indicador.lgpd.declaradoPor}`)}
            </>
          )}
        </Box>

        {/* Dados da Indicação */}
        <Typography variant="subtitle2" color="primary" mb={1}>Indicação</Typography>
        <Box sx={{ backgroundColor: 'white', borderRadius: 1, p: 2, mb: 2 }}>
          {campo('Tipo', tipoIndicacao?.nome)}
          <Divider />
          {campo('Cliente', proposta?.cliente?.nome)}
          <Divider />
          {campo('Valor da Proposta', proposta?.valor?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }))}
          <Divider />
          <Stack direction="row" justifyContent="space-between" alignItems="center" py={0.5}>
            <Typography variant="body2" color="text.secondary">Valor a Pagar</Typography>
            <Chip label={valorPagamento} color="success" size="small" />
          </Stack>
        </Box>

        <Button fullWidth variant="outlined" onClick={onClose}>Fechar</Button>
      </Box>
    </Modal>
  );
}

ModalPagamentoIndicador.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  proposta: PropTypes.object,
};